import React from "react"
import { Link } from "gatsby"

import MainLayout from "../components/layout"
import SEO from "../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../components/SubPages/IntroSubPages/introSubPages"
import Grid from "../components/SubPages/careerpage/grid"
import Para from "../components/SubPages/careerpage/textarea"

import Constants from "../constants/careers.json"

import backgroundImg from "../images/careers/back.png"
import solutionsImg from "../images/partners/Solutions.png"
import expertsImg from "../images/partners/Expertise.png"
import reliableImg from "../images/partners/reliable.png"
import supportImg from "../images/partners/support.png"
import back1 from "../images/careers/Full Stack engineer.png"
import back2 from "../images/careers/QA.png"
import back3 from "../images/careers/internships.png"

const CareersPage = () => (
  <MainLayout>
    <SEO
      title="Careers"
      description="Accelerate your business with Meetrix. Join us to grow your business together with Meetrix"
      pagePath="/careers"
      schema={`{
          "@context": "https://meetrix.io/partners",
          "@type": "WebPage",
          "mainEntity": {
            "@type": "Organization",
            "name": "Meetrix.io",
          }
        }`}
    />
    <Intro
      title={Constants.Intro.title}
      description={Constants.Intro.description}
      background={backgroundImg}
      blueTitle={Constants.Intro.blueTitle}
    />
    <Para paratxt={Constants.Para.paratxt.t1}></Para>
    <Grid
      headin={Constants.Grid.headin.t1}
      sub_headin={Constants.Grid.sub_headin.st1}
      side_img={back1}
      tblhead_black={Constants.Grid.tblhead_black}
      bottomtext_black={Constants.Grid.bottomtext_black}
      td_text1={Constants.Grid.td_text1.td_t1}
      td_text2={Constants.Grid.td_text2.td_t1}
      td_text3={Constants.Grid.td_text3.td_t1}
      td_text4={Constants.Grid.td_text4.td_t1}
      td_text5={Constants.Grid.td_text5.td_t1}
      requirment_black={Constants.Grid.requirment_black}
      li_txt1={Constants.Grid.li_txt1.li1}
      li_txt2={Constants.Grid.li_txt2.li1}
      li_txt3={Constants.Grid.li_txt3.li1}
      li_txt4={Constants.Grid.li_txt4.li1}
      li_txt5={Constants.Grid.li_txt5.li1}
      li_txt6={Constants.Grid.li_txt6.li1}
      li_txt7={Constants.Grid.li_txt7}
    />
    <Grid
      headin={Constants.Grid.headin.t3}
      sub_headin={Constants.Grid.sub_headin.st3}
      side_img={back3}
      tblhead_white={Constants.Grid.tblhead_white}
      bottomtext_white={Constants.Grid.bottomtext_white}
      tec_li1={Constants.Grid.tec_li1}
      tec_li2={Constants.Grid.tec_li2}
      tec_li3={Constants.Grid.tec_li2}
      tec_li4={Constants.Grid.tec_li4}
      tec_li5={Constants.Grid.tec_li5}
      tec_li6={Constants.Grid.tec_li6}
      tec_li7={Constants.Grid.tec_li7}
      requirment_white={Constants.Grid.requirment_white}
      li_txt1={Constants.Grid.li_txt1.li3}
      li_txt2={Constants.Grid.li_txt2.li3}
    />
    {/* 
   
  <Grid
    headin={Constants.Grid.headin.t3}
    sub_headin={Constants.Grid.sub_headin.st3}
    side_img={back3}
    tblhead_black={Constants.Grid.tblhead_black}
    tec_li1={Constants.Grid.tec_li1}
    tec_li2={Constants.Grid.tec_li2}
    tec_li3={Constants.Grid.tec_li2}
    tec_li4={Constants.Grid.tec_li4}
    tec_li5={Constants.Grid.tec_li5}
    tec_li6={Constants.Grid.tec_li6}
    tec_li7={Constants.Grid.tec_li7}
    bottomtext_black={Constants.Grid.bottomtext_black}
    requirment_black={Constants.Grid.requirment_black}
    li_txt1={Constants.Grid.li_txt1.li3}
    li_txt2={Constants.Grid.li_txt2.li3}
    />

  */}
  </MainLayout>
)

export default CareersPage
